<template>
  <el-row :gutter="24">
    <el-col :span="12">
      <p>День рождения: {{ props.row.birthday || '(нет данных)' }}</p>
      <p>Паспорт: {{ props.row.passport || '(нет данных)' }}</p>
      <p>
        Водительское удостоверение:
        {{ props.row.driver_licence || '(нет данных)' }}
      </p>
      <p>Email: {{ props.row.email || '(нет данных)' }}</p>
      <p>ИНН: {{ props.row.inn || '(нет данных)' }}</p>
      <p>Подтвержден: {{ props.row.is_approve ? 'Да' : 'Нет' }}</p>
    </el-col>
    <el-col :span="12">
      <p>Файл подтверждение личности</p>
      <upload-document-modal
        name-document="Паспорт"
        :data-edit="documents.user"
        :source-id="documents.user.sourceId"
        :need-additional="false"
      />
    </el-col>
  </el-row>
</template>

<script>
import UploadDocumentModal from '@/components/Upload/UploadDocumentModal'

export default {
  name: 'UserInfo',
  components: { UploadDocumentModal },
  props: {
    props: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      documents: {
        user: {
          sourceModelName: 'users',
          sourceId: this.props.row.id,
          documentType: 'passport',
        },
      },
    }
  },
  methods: {},
}
</script>
